import { useState } from "react";
import { ChevronLeft, ChevronRight } from "react-feather";

const images = [
  { src: "/a1.jpg", caption: "A taste of purity." },
  { src: "/a2.jpg", caption: "Crafted for the senses." },
  { src: "/a3.jpg", caption: "Whispers of the Aegean." },
  { src: "/a4.jpg", caption: "Elegance in every detail." },
  { src: "/a5.jpg", caption: "Flavors beyond borders." },
  { src: "/a6.jpg", caption: "Sunlight and simplicity." },
  { src: "/a7.jpg", caption: "A world of its own." },
  { src: "/a8.jpg", caption: "Gastronomy reborn." },
  { src: "/a9.jpg", caption: "Pleasure in the present." },
  { src: "/a10.jpg", caption: "Essence of summer." },
  { src: "/a11.jpg", caption: "Moments never scripted." },
  { src: "/a12.jpg", caption: "Luxury redefined." },
  { src: "/a13.jpg", caption: "Unseen, unforgettable." },
  { src: "/a14.jpg", caption: "Let the senses guide you." },
];

export default function FarFromPage() {
  const [index, setIndex] = useState(0);

  const prev = () => {
    setIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const next = () => {
    setIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  return (
    <div className="relative w-full h-screen bg-black overflow-hidden">
      {/* Marquee Text Centered */}
      <div className="absolute inset-0 z-50 pointer-events-none flex items-center justify-center px-4">
        <div className="w-full overflow-hidden">
          <div className="inline-block animate-marquee-slow whitespace-nowrap text-[26px] sm:text-[32px] md:text-[90px] font-normal text-white font-saol leading-none">
            {Array(3)
              .fill("far from the world. far from the obvious")
              .map((text, i) => (
                <span className="mx-6 md:mx-12" key={i}>
                  {text}
                </span>
              ))}
          </div>
        </div>
      </div>

      {/* Image Slide */}
      <div className="w-full h-full relative p-4 md:p-12 box-border font-saol">
        <div
          className="w-full h-full transition-all duration-700 ease-in-out"
          key={index}
        >
          <img
            src={images[index].src}
            alt={`Slide ${index + 1}`}
            className="w-full h-full object-cover object-center"
          />

          {/* Caption */}
          <div className="absolute bottom-4 md:bottom-10 left-4 md:left-10 text-white text-xs sm:text-sm md:text-4xl max-w-[75%] md:max-w-[60%] z-10">
            {images[index].caption}
          </div>

          {/* Index */}
          <div className="absolute bottom-4 md:bottom-10 right-4 md:right-10 text-white text-xs sm:text-sm md:text-4xl z-10">
            {index + 1}/15
          </div>
        </div>

        {/* Left Button */}
        <button
          onClick={prev}
          className="absolute left-2 md:left-4 top-1/2 transform -translate-y-1/2 transition-all hover:bg-black/50 p-2 md:p-3 rounded-full z-10"
        >
          <ChevronLeft size={24} className="md:w-[30px] md:h-[30px]" color="#fff" />
        </button>

        {/* Right Button */}
        <button
          onClick={next}
          className="absolute right-2 md:right-4 top-1/2 transform -translate-y-1/2 transition-all hover:bg-black/50 p-2 md:p-3 rounded-full z-10"
        >
          <ChevronRight size={24} className="md:w-[30px] md:h-[30px]" color="#fff" />
        </button>
      </div>
    </div>
  );
}
